export default __webpack_public_path__ + "static/istio-up-and-running-ee287efdef5c07d02774114d33bba12f.webp";